import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
// BrowserTransferStateModule removed in v14
import { TransferHttpCacheInterceptor } from './transfer-http-cache.interceptor';

/**
 * An NgModule used in conjunction with `ServerTransferHttpCacheModule` to transfer cached HTTP
 * calls from the server to the client application.
 */
@NgModule({
  imports: []
})
export class TransferHttpCacheModule {
  static forRoot(): ModuleWithProviders<TransferHttpCacheModule> {
    return {
      ngModule: TransferHttpCacheModule,
      providers: [
        TransferHttpCacheInterceptor,
        { provide: HTTP_INTERCEPTORS, useExisting: TransferHttpCacheInterceptor, multi: true },
      ]
    };
  }
}
